import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import router from "../../../../router";
import eventBus from "../../../event-bus/eventBus";

const sendOffer = {
    namespaced: true,
    state: {},
    mutations: {
        SUCCESS_DOCUMENT_SEND(state, response) {           
            if (router.currentRoute.name === 'OffersList') {
                eventBus.$emit('sendDocumentSuccess', response.data);
            } else {
                localStorage.setItem("messageOfferSave", response.data.message);
                localStorage.setItem("textOfferSave", response.data.data.textInfo);
                router.push({ path:"/offers" });
            }          
        },
        FAILURE_DOCUMENT_SEND(state, error) {
            if (error.response.data.errors.type && error.response.data.errors.type[0] === 'diskLimitExceeded') {
                eventBus.$emit('projectDiskLimitExceeded', error.response.data.errors);
            } else {
                console.log(error);
            }     
        },
    },
    actions: {
        sendOffer: function({dispatch}, payload) {
            dispatch('manageEmailForm/updateEmailIsSending', true, {root:true})
            let promise = sendRequest("post", config.baseURLApi + "/offers/send/" + payload.id, {}, payload);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDocumentSend", result[1])
                } else {
                    dispatch("failureDocumentSend", result[1]);
                }
                dispatch('manageEmailForm/updateEmailIsSending', false, {root:true})
                dispatch('manageEmailForm/updateIsEmailFormVisible', false, {root:true})
            });
        },
        successDocumentSend: function({commit}, response) {
            commit("SUCCESS_DOCUMENT_SEND", response);  
        },
        failureDocumentSend: function({ commit }, error) {
            commit("FAILURE_DOCUMENT_SEND", error);
        }
    }
}

export default sendOffer;